export default __webpack_public_path__ + "static/media/oob-full-web.e911c21b.avif";